import { InputMask } from "@react-input/mask";

export const MaskedInput: React.FC<{
  id: string;
  idCnpj?: any;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  mask: string;
  isInvalid?: boolean;
  placeholder?: string;
}> = ({ id, idCnpj, value, onChange, onBlur, mask, isInvalid, placeholder }) => (
  <InputMask
    id={id}
    className={`form-control ${isInvalid ? "is-invalid" : ""}`}
    value={value}
    placeholder={placeholder}
    onChange={onChange}
    onBlur={onBlur}
    mask={mask}
    replacement={{ _: /\d/ }}
    disabled={idCnpj ? true : false}
  />
);
